"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeBeet = exports.Store = void 0;
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const storeDiscriminator = [130, 48, 247, 244, 182, 191, 30, 26];
class Store {
    constructor(admin, name, description) {
        this.admin = admin;
        this.name = name;
        this.description = description;
    }
    static fromArgs(args) {
        return new Store(args.admin, args.name, args.description);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return Store.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find Store account at ${address}`);
        }
        return Store.fromAccountInfo(accountInfo, 0)[0];
    }
    static deserialize(buf, offset = 0) {
        return exports.storeBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.storeBeet.serialize({
            accountDiscriminator: storeDiscriminator,
            ...this,
        });
    }
    static byteSize(args) {
        const instance = Store.fromArgs(args);
        return exports.storeBeet.toFixedFromValue({
            accountDiscriminator: storeDiscriminator,
            ...instance,
        }).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(Store.byteSize(args), commitment);
    }
    pretty() {
        return {
            admin: this.admin.toBase58(),
            name: this.name,
            description: this.description,
        };
    }
}
exports.Store = Store;
exports.storeBeet = new beet.FixableBeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['admin', beetSolana.publicKey],
    ['name', beet.utf8String],
    ['description', beet.utf8String],
], Store.fromArgs, 'Store');
//# sourceMappingURL=Store.js.map